// Exports
export default {
	"description": "description_hLBBd"
};
